import JSONPretty from 'react-json-pretty';
import * as JSONPrettyMon from './pretty-print-json.style.scss';

type PrettyPrintJsonProps = {
  jsonData: object;
};

export const PrettyPrintJson = ({ jsonData }: PrettyPrintJsonProps) => {
  if (!jsonData) return null;
  return <JSONPretty data={jsonData} theme={JSONPrettyMon} space={4} />;
};
